import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import type { GoogleSearchSuggestionsResponse } from './types';
import type { Environment } from 'client-site-chrome-ui/environment';

const SUGGESTIONS_LIMIT = 5;

export const fetchGoogleSearchSuggestions = async (
  env: Environment,
  term: string,
  userId: string,
) => {
  const baseUrl =
    env === 'production'
      ? 'https://api.notonthehighstreet.com/api/search-suggestions/v1'
      : 'https://api.public.shared.qa.noths.com/api/search-suggestions/v1';
  const fullUrl = `${baseUrl}?query=${term}&limit=${SUGGESTIONS_LIMIT}&userId=${userId}`;

  try {
    const response = await fetchJSONWithTimeout(fullUrl, {
      mode: 'cors',
    });

    if (response.ok) {
      const body: GoogleSearchSuggestionsResponse = await response.json();

      return body;
    }
  } catch (e) {
    console.error(`Error thrown during fetch for Google suggestions: "${(e as Error).message}"`);
  }

  return null;
};
